import Loadable from "../../react-loadable";

const Main = Loadable({
  loader: () => import("./browser/index"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default Main;



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/Browser.js